import { styled } from 'styled-components'
import { SkladsList } from '../modules/SkladsList'
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height:100%;
  padding-left: 16px;
  padding-right: 16px;
  padding-top:16px;
  box-sizing: border-box;
  padding-bottom: 8vh;// от полоски сафари
`
const SkladsPage = () => {
  return (
    <Wrapper>
        <SkladsList/>
    </Wrapper>
  )
}

export default SkladsPage